import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tag from 'src/store/models/Tag';
import { colorUtils } from 'src/mixins/colors-utils';
export default {
  mixins: [colorUtils],
  data: function data() {
    return {
      tagEntities: null
    };
  },
  props: {
    tags: {
      type: Array,
      validator: function validator(value) {
        // All elements in value must have a tag_id, name, and tag_list.color
        return value.every(function (tag) {
          return tag.tag_id && tag.name && tag.tag_list && tag.tag_list.color;
        });
      }
    },
    tagIds: {
      type: Array,
      validator: function validator(value) {
        // All elements in value must have a tag_id, name, and tag_list.color
        return value.every(function (tagId) {
          return typeof tagId === 'number';
        });
      }
    },
    limit: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0;
      }
    },
    moreChipClass: {
      type: String,
      default: ''
    }
  },
  watch: {
    tagIds: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.tagEntities = Tag.query().with('tag_list').whereIdIn(newVal).get();
        }
      }
    }
  },
  computed: {
    filteredTags: function filteredTags() {
      var tags = this.tags ? this.tags : this.tagEntities;
      if (!this.limit) return tags;

      if (tags && tags.length > this.limit) {
        var len = tags.length;
        tags = tags.slice(0, this.limit - 1);
        tags.push({
          name: this.$t('components.entries.x_more_tags', {
            el: len - (this.limit - 1)
          }),
          class: this.moreChipClass,
          tag_list: {
            color: '#fff',
            'text-color': 'black'
          }
        });
      }

      return tags;
    }
  },
  methods: {
    getTagColor: function getTagColor(tag) {
      return tag.integration_code ? tag.color : tag.tag_list.color;
    }
  }
};